import { createContext, useContext } from 'react';

// Context for sharing CMS data across components
const CmsContext = createContext({
    schemas: [],
    schemasLoading: true,
    schemasRefreshing: false,
    refreshSchemas: () => {},
});

export const useCms = () => useContext(CmsContext);

export default CmsContext;
